import _ from "lodash";
import moment from "moment";
import React, { PropTypes } from "react";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";
import { FormattedDate, FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { toast } from "react-toastify";
import {
    ADMINISTRATOR,
    AGENT,
    DIRECTOR,
    FINTECH,
    HIGH_MANAGEMENT_WITH_FINANCE,
    HR_CLERK,
    INFORMATION_AGENT,
    MANAGER,
    PLAN_ADMINISTRATOR
} from "../../../../../../../utils/Roles";
import * as types from "../../../../../../../utils/data/dataActionTypes";
import * as dataActions from "../../../../../../../utils/data/dataActions";
import {
    BILLING_PERIODS_CLIENT_ALL,
    CLASSES,
    DIVISIONS,
    EMPLOYMENTS,
    MEMBER_COVERAGES
} from "../../../../../../../utils/data/models";
import userHasAccess from "../../../../../../../utils/userHasAccess";
import { BSModal, EditButton, MessageBox, Render } from "../../../../../../common";
import { DataTable } from "../../../../../../common/DataTable";
import { getRetroactiveLimitDate } from "../../../../../../common/RetroactiveData/RetroactiveLimitHelper";
import { isSimpleFetchToast } from "../../../../../../common/RouteValidators/ClientValidationHelper";
import { toLocaleDate } from "../../../../../../common/dateHelper";
import { LIST_API_HOOK_ERRORS } from "../../../../../../common/enums/apiHooksErrorType";
import { toCamelCase } from "../../../../../../common/form/DBEnumStringHelper";
import { RectangleSpinner } from "../../../../../../common/spinners";
import { canViewSyncStatus, getLatestMemberSyncsV2, getOverlayForSync } from "../../../../../../common/synchronization/SynchronizationHelper";
import { PRICE_LIST } from "../../../../../admin/guarantees/enums/guaranteeTypes";
import { MEMBER } from "../../../../../synchronization/enums/syncElementTypes";
import { RECURRING } from "../../../../enums/billingPeriodTypes";
import { ACTIVE, IMPLEMENTATION, INACTIVE, TERMINATED } from "../../../../enums/clientStatusTypes";
import { ELIGIBILITY } from "../../../../enums/synchronizationOptions";
import { EMPLOYMENT } from "../../../members/enums/employmentTypes";
import { BasicMemberCoverageFields, MemberCoverageStatus } from "./";
import MemberCoverageBlockWithdrawal from "./MemberCoverageBlockWithdrawal";
import { FIRST_NAME, LAST_NAME } from "./enums/invalidMemberNameSynchroTypes";
import memberCoverageAddTypes, { NEW } from "./enums/memberCoverageAddTypes";
import {
    ANNUAL_DEACTIVATION,
    OTHER,
    PERMANENT_DEACTIVATION,
    SESSION_DEACTIVATION,
} from "./enums/memberCoverageInactivityReasons";

const CLASS_GUARANTEES = { ...CLASSES, name: "classGuarantees" };
const PROFILE_REQUIRED_FIELDS = [
    "firstName",
    "lastName",
    "birthdate",
    "address",
    "city",
    "countryCode",
    "provinceCode",
    "postalCode",
    "employment",
    "memberGenderType",
];

class MemberCoverageDataTable extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            latestCoverage: null,
            secondLatestCoverage: null,
            showErrorModal: false,
            showModal: false,
            submitErrors: {},
            blockInactivationSubmission: false,
            maximumRetroactiveDate: undefined,
            fetchingRetroactiveDate: true,
            memberCoverageSyncs: null,
            areCoveragesEnabledToModification: false,
            isValidForSynchroConfirm: false,
            isClientValidForSynchro: false,
            isMemberValidForSynchro: false,
            memberSyncs: [],
            currentUserRoleId: localStorage.getItem("roleId") || ""
        };

        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.cloneLatestCoverageModel = this.cloneLatestCoverageModel.bind(this);
        this.createCoverage = this.createCoverage.bind(this);
        this.generateAddButton = this.generateAddButton.bind(this);
        this.getData = this.getData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.openModal = this.openModal.bind(this);
        this.updateCoverage = this.updateCoverage.bind(this);
        this.updateBlockCoverage = this.updateBlockCoverage.bind(this);
        this.getViewOnlyMemberCoverageForClientStatusType = this.getViewOnlyMemberCoverageForClientStatusType.bind(
            this
        );

        this.viewOnlyMemberCoverageForImplementation = !userHasAccess(HIGH_MANAGEMENT_WITH_FINANCE, true);
        this.viewOnlyMemberCoverageForActive = !userHasAccess(
            [DIRECTOR, MANAGER, AGENT, PLAN_ADMINISTRATOR, ADMINISTRATOR, FINTECH],
            true
        );
        this.viewOnlyMemberCoverageForInactive = !userHasAccess(
            [ADMINISTRATOR, FINTECH, DIRECTOR, MANAGER, AGENT],
            true
        );
        this.viewOnlyForTerminated = !userHasAccess(FINTECH);
        this.setBlockInactivationSubmission = this.setblockInactivationSubmission.bind(this);
        this.setmaximumRetroactiveDate = this.setmaximumRetroactiveDate.bind(this);
        this.isMemberCoverageValid = this.isMemberCoverageValid.bind(this);
        this.showWarningSynchroMessage = this.showWarningSynchroMessage.bind(this);
        this.closeSynchroConfirmation = this.closeSynchroConfirmation.bind(this);
        this.onStartDateChange = this.onStartDateChange.bind(this);
    }

    componentWillMount() {
        this.props.dataActions.clearDataList(MEMBER_COVERAGES);
        const classesFilters = ["clientId==" + this.props.clientId];
        const classesSortBy = [`name:asc`]; //localizations.${this.props.authLanguageCode}.
        this.props.dataActions.getDataList(CLASSES, 0, 0, "", classesSortBy, classesFilters);

        const divisionsFilters = ["clientId==" + this.props.clientId];
        const divisionsSortBy = [`name:asc`]; //localizations.${this.props.authLanguageCode}.
        this.props.dataActions.getDataList(DIVISIONS, 0, 0, "", divisionsSortBy, divisionsFilters);

        const employmentsSortBy = [`startDate:desc`];
        const employmentsFilters = [`memberEmployments.memberId==${this.props.memberId};memberEmployments.employmentType==${EMPLOYMENT}`];
        this.props.dataActions.getDataList(EMPLOYMENTS, 0, 0, "", employmentsSortBy, employmentsFilters);

        if (this.props.billingPeriodsList.length <= 0) {
            //If Billing periods were not loaded (refresh)
            const billingPeriodFields = "billingPeriodId,endDate,startDate,localizations";
            const billingPeriodfilters = [`billingPeriods.clientId==${this.props.clientId}`];
            this.props.dataActions.getDataList(
                BILLING_PERIODS_CLIENT_ALL,
                0,
                0,
                "",
                ["startDate:desc"],
                billingPeriodfilters,
                null,
                {},
                billingPeriodFields
            );
        }
        this.setmaximumRetroactiveDate();
        const countryCodeCanada = "CA";
        const isClientValidForSynchro = this.props.activeClient.syncType === ELIGIBILITY.value &&
            this.props.activeClient.countryCode == countryCodeCanada &&
            this.props.activeClient.clientBillingPeriodType == RECURRING.value &&
            [ACTIVE.value, INACTIVE.value].includes(this.props.activeClient.clientStatusType);
        const isMemberValidForSynchro = !this.props.activeMember.isSyncDisabled && this.props.activeMember.countryCode == countryCodeCanada
            && this.props.activeMember.firstName != FIRST_NAME && this.props.activeMember.lastName != LAST_NAME;
        this.setState({
            isClientValidForSynchro: isClientValidForSynchro,
            isMemberValidForSynchro: isMemberValidForSynchro
        });
    }

    componentWillUnmount() {
        this.props.dataActions.clearDataList(BILLING_PERIODS_CLIENT_ALL);
        this.props.dataActions.clearDataList(CLASS_GUARANTEES);
        this.props.dataActions.clearDataList(MEMBER_COVERAGES);
        this.props.dataActions.clearDataList(EMPLOYMENTS);
    }

    setmaximumRetroactiveDate() {
        getRetroactiveLimitDate(this.props.clientId, (result) => {
            this.setState({
                maximumRetroactiveDate: result,
                fetchingRetroactiveDate: false,
                areCoveragesEnabledToModification: true,
            });
        });
    }

    setblockInactivationSubmission(value) {
        this.setState({ blockInactivationSubmission: value });
    }

    cleanField(value, prerequisites = true) {
        return prerequisites && !!value && String(value).trim() !== "" ? value : null;
    }

    getViewOnlyMemberCoverageForClientStatusType() {
        const { clientStatusType } = this.props;

        switch (clientStatusType) {
            case IMPLEMENTATION.value:
                return this.viewOnlyMemberCoverageForImplementation;
            case ACTIVE.value:
                return this.viewOnlyMemberCoverageForActive;
            case INACTIVE.value:
                return this.viewOnlyMemberCoverageForInactive;
            case TERMINATED.value:
                return this.viewOnlyForTerminated;
        }
    }

    cleanValues(values) {
        const newValues = { ...values };
        delete newValues.furthestDate;
        newValues.endDate = this.cleanField(newValues.endDate);
        newValues.isBlockedFromWithdrawal =
            newValues.isBlockedFromWithdrawal && newValues.isBlockedFromWithdrawal !== false;
        newValues.isInactive = newValues.isInactive && newValues.isInactive !== false;
        newValues.isInactiveReasonType = this.cleanField(newValues.isInactiveReasonType, newValues.isInactive);
        newValues.isInactiveWithdrawalDate = this.cleanField(
            newValues.isInactiveWithdrawalDate,
            newValues.isInactive &&
            [PERMANENT_DEACTIVATION.value, ANNUAL_DEACTIVATION.value, SESSION_DEACTIVATION.value].includes(
                newValues.isInactiveReasonType
            )
        );
        newValues.isInactiveOtherReason = this.cleanField(
            newValues.isInactiveOtherReason,
            newValues.isInactive && newValues.isInactiveReasonType === OTHER.value
        );
        newValues.memberCoverageGuarantees = newValues.memberCoverageGuarantees
            .filter((guarantee) => guarantee.checked === true)
            .map((guarantee) => {
                let data = { ...guarantee, guaranteeType: guarantee.guarantee.guaranteeType };
                delete data.checked;
                delete data.guarantee;
                return data;
            });

        delete newValues.memberCoveragePartnerHash;
        if (newValues.occupation && typeof newValues.occupation === "string" && newValues.occupation.trim() === "") newValues.occupation = null;

        return newValues;
    }

    closeErrorModal() {
        this.setState({ showErrorModal: false, submitErrors: {} });
    }

    closeModal() {
        this.setState({ showModal: false, showModalConfirm: false });
    }

    createCoverage(values) {
        const newValues = this.cleanValues(values);
        return this.props.dataActions.createDataItem(MEMBER_COVERAGES, newValues).then((res) => {
            const isSimpleFetchError = isSimpleFetchToast(res);
            if (res.type === types.CREATE_DATA_ITEM_FAILURE && !isSimpleFetchError) {
                if (LIST_API_HOOK_ERRORS.includes(res.payload.error.data.message)) {
                    toast(<FormattedMessage id={res.payload.error.data.message} />, {
                        type: toast.TYPE.ERROR,
                        autoClose: true,
                    });
                } else {
                    this.setState({
                        showErrorModal: true,
                        submitErrors: res.payload.error.data,
                    });
                }
            } else {
                this.closeModal();
                this.getData(this.props.offset, this.props.limit, this.props.q, this.props.sortBy, this.props.filters);
                this.props.getMember();
            }
        });
    }

    createEmptyCoverageModel(memberId) {
        const furthestDate = !!this.state.latestCoverage ? moment(toLocaleDate(this.state.latestCoverage.startDate)) : null;
        return {
            classId: null,
            divisionId: null,
            isInactive: false,
            defineEndDate: null,
            endDate: null,
            memberCoverageGuarantees: [],
            isInactiveOtherReason: "",
            isInactiveReasonType: null,
            isInactiveWithdrawalDate: false,
            isRemovedFromList: false,
            mustNotInvoice: false,
            mustBePaidToBroker: false,
            isPaid: false,
            memberId,
            occupation: null,
            isBlockedFromWithdrawal: false,
            salary: "",
            startDate: "",
            furthestDate,
        };
    }

    cloneLatestCoverageModel() {
        if (this.state.latestCoverage) {
            const latestCoverage = _.cloneDeep(this.state.latestCoverage);
            _.unset(latestCoverage, "billingPeriod");
            _.unset(latestCoverage, "billingPeriodId");
            _.unset(latestCoverage, "memberCoverageId");
            _.unset(latestCoverage, "startDate");
            _.unset(latestCoverage, "endDate");
            latestCoverage.defineEndDate = false;
            return latestCoverage;
        } else {
            return null;
        }
    }

    handleSubmit() {
        const validationErrors = this.refs.form.getWrappedInstance().submit();
        if (Object.keys(validationErrors).length) {
            return validationErrors;
        }
    }

    openModal(type) {
        if (!this.props.missingProfileFields.length) {
            this.setState({ showModal: type });
        } else {
            this.setState({
                showErrorModal: true,
                submitErrors: {
                    error: "missing_required_fields",
                    data: [...this.props.missingProfileFields],
                },
            });
        }
    }
    showWarningSynchroMessage() {
        this.setState({ showSynchroModal: true });
    }
    closeSynchroConfirmation() {
        this.setState({ showSynchroModal: false });
    }
    onStartDateChange(value, hasSuccess) {
        const { isClientValidForSynchro, isMemberValidForSynchro } = this.state;
        const isPlanAdministratorOrHRClerk = [PLAN_ADMINISTRATOR.roleId.toString(), HR_CLERK.roleId.toString()].includes(this.state.currentUserRoleId);
        if (isClientValidForSynchro && isMemberValidForSynchro && hasSuccess && isPlanAdministratorOrHRClerk) {
            this.setState({
                isValidForSynchroConfirm: value,
            });
        }
    }
    updateCoverage(values) {
        const newValues = this.cleanValues(values);
        this.props.dataActions.updateDataItem(MEMBER_COVERAGES, newValues).then((res) => {
            const isSimpleFetchError = isSimpleFetchToast(res);
            if (res.type === types.UPDATE_DATA_ITEM_FAILURE && !isSimpleFetchError) {
                if (LIST_API_HOOK_ERRORS.includes(res.payload.error.data.message)) {
                    toast(<FormattedMessage id={res.payload.error.data.message} />, {
                        type: toast.TYPE.ERROR,
                        autoClose: true,
                    });
                } else {
                    if (res.payload.error && res.payload.error.data && res.payload.error.data.error == "missing_required_fields") {
                        this.setState({
                            showErrorModal: true,
                            submitErrors: {
                                error: res.payload.error.data.error,
                                data: [...this.props.missingProfileFields],
                            },
                        });
                    }
                    else {
                        this.setState({
                            showErrorModal: true,
                            submitErrors: res.payload.error.data,
                        });
                    }
                }
            } else {
                this.closeModal();
                this.getData(this.props.offset, this.props.limit, this.props.q, this.props.sortBy, this.props.filters);
                this.props.getMember();
            }
        });
    }

    updateBlockCoverage(values) {
        this.props.dataActions.updateDataItem(MEMBER_COVERAGES, values.memberCoverage).then(() => {
            this.props.getMember();
        });
    }

    getMemberCoverageType(memberCoverage) {
        if (!memberCoverage || !memberCoverage.memberCoverageGuarantees
            || (Array.isArray(memberCoverage.memberCoverageGuarantees) && memberCoverage.memberCoverageGuarantees.length === 0)) {
            return <FormattedMessage id="memberCoverages.types.waived" />;
        }
        const memberCoverageGuarantees = memberCoverage.memberCoverageGuarantees;

        let defaultType = (<FormattedMessage id="memberCoverages.types.multiple" />);
        let otherType = (<FormattedMessage id="memberCoverages.types.other" />);
        let isMultiple = false;
        let isNullCoverageType = true;

        let typeLookUp = null;

        for (const cov of memberCoverageGuarantees) {
            if (
                typeLookUp &&
                cov.guarantee.guaranteeType == PRICE_LIST.value &&
                !!cov.coverageType &&
                cov.coverageType !== typeLookUp
            ) {
                /** 
                 * Here we know that there's at least one different type, so we can return multiple early
                 */
                isMultiple = true;
                break;
            }

            if (cov && cov.coverageType) {
                typeLookUp = cov.coverageType;
                isNullCoverageType = false;
            }
        }

        if (isMultiple) return defaultType;
        if (isNullCoverageType) return otherType;

        typeLookUp = typeLookUp && toCamelCase(typeLookUp.toLowerCase());
        return (<FormattedMessage id={`memberCoverages.types.${typeLookUp}`} />);
    }

    getCols() {
        const showBillingPeriod = this.props.clientBillingPeriodType !== "RECURRING";
        let cols = [];

        const syncCol = canViewSyncStatus(this.props.activeClient, MEMBER) ? {
            name: <FormattedMessage id="memberCoverages.datatable.columns.sync" />,
            display: (memberCoverage) => this.isMemberCoverageValid(memberCoverage),
            widthPct: 7,
        } : undefined;

        if (showBillingPeriod) {
            cols.push({
                name: <FormattedMessage id="memberCoverages.datatable.columns.period" />,
                display: (memberCoverage) => {
                    if (memberCoverage.billingPeriodId && this.props.billingPeriodsList.length > 0) {
                        const billingPeriod = _.find(this.props.billingPeriodsList, {
                            billingPeriodId: memberCoverage.billingPeriodId,
                        }) || { name: "" };
                        return <span>{billingPeriod.localizations[this.props.authLanguageCode].name}</span>;
                    } else {
                        return <span />;
                    }
                },
                widthPct: 15,
            });
        }

        cols = cols.concat([
            {
                name: <FormattedMessage id="memberCoverages.datatable.columns.date" />,
                display: (memberCoverage) => {
                    if (memberCoverage.endDate) {
                        return (
                            <span>
                                <FormattedDate
                                    value={toLocaleDate(memberCoverage.startDate)}
                                    year="numeric"
                                    month="long"
                                    day="2-digit"
                                    timeZone="UTC"
                                />
                                <span> - </span>
                                <FormattedDate
                                    value={toLocaleDate(memberCoverage.endDate)}
                                    year="numeric"
                                    month="long"
                                    day="2-digit"
                                    timeZone="UTC"
                                />
                            </span>
                        );
                    }

                    return (
                        <span>
                            <FormattedMessage id="memberCoverages.datatable.columns.periodFrom" />
                            <FormattedDate
                                value={memberCoverage.startDate}
                                year="numeric"
                                month="long"
                                day="2-digit"
                                timeZone="UTC"
                            />
                        </span>
                    );
                },
                widthPct: showBillingPeriod ? 18 : 20,
            },
            {
                name: <FormattedMessage id="memberCoverages.datatable.columns.type" />,
                display: (memberCoverage) => this.getMemberCoverageType(memberCoverage),
                widthPct: showBillingPeriod ? 7 : 12,
            },
            {
                name: <FormattedMessage id="memberCoverages.datatable.columns.class" />,
                display: (memberCoverage) => <span>{memberCoverage.memberClass.name}</span>,
                widthPct: showBillingPeriod ? 7 : 14,
            },
            {
                name: <FormattedMessage id="members.datatable.columns.division" />,
                display: (memberCoverage) => <span>{memberCoverage.division.name}</span>,
                widthPct: showBillingPeriod ? 12 : 16,
            },
            {
                name: <FormattedMessage id="memberCoverages.datatable.columns.status" />,
                display: (memberCoverage) => (
                    <MemberCoverageStatus
                        businessAccountType={this.props.businessAccountType}
                        memberCoverage={memberCoverage}
                        authLanguageCode={this.props.authLanguageCode}
                    />
                ),
                widthPct: 10,
            },
            syncCol
        ].filter((col => col !== undefined)));
        if (this.props.clientBillingPeriodType !== "MANUAL") {
            cols.push({
                name: <FormattedMessage id="memberCoverages.datatable.columns.occupation" />,
                display: (memberCoverage) => <span>{memberCoverage.occupation}</span>,
                widthPct: 11,
            });
        } else {
            cols.push({
                name: <FormattedMessage id="members.member.actions.blockFromWithdrawal" />,
                display: (memberCoverage) => (
                    <MemberCoverageBlockWithdrawal
                        memberCoverage={memberCoverage}
                        onSubmit={this.updateBlockCoverage}
                    />
                ),
                widthPct: 11,
            });
        }
        cols.push({
            name: <FormattedMessage id="datatable.actions" />,
            display: (memberCoverage) => this.generateActionButtons(memberCoverage),
            widthPct: 10,
        });
        return cols;
    }


    isMemberCoverageValid(memberCoverage) {
        if (this.state.memberCoverageSyncs === null) {
            return <RectangleSpinner className="spinner-rect-col" />;
        }
        const memberCoverageSync = this.state.memberCoverageSyncs.find(
            (coverage) => coverage.memberCoverageId == memberCoverage.memberCoverageId
        );
        let memberData = _.cloneDeep(this.props.activeMember);
        if (memberCoverage) memberData.memberCoverages = [memberCoverage];
        const data = { "memberCoverage": _.cloneDeep(memberCoverage), "client": this.props.activeClient, "member": memberData };
        return getOverlayForSync(data, memberCoverageSync, "memberCoverages.datatable", "memberCoveragePartnerHash", "memberCoverageHash", "memberCoverage");
    }

    generateActionButtons(memberCoverage) {
        const {
            classesList,
            clientBillingPeriodType,
            businessAccountType,
            clientId,
            items,
            ratePeriodType,
            missingProfileFields,
            clientLastActiveDate,
            clientStatus,
            activeMember,
            addType,
        } = this.props;
        let readOnly = true;
        if (!!this.state.latestCoverage) {
            readOnly = memberCoverage.memberCoverageId !== this.state.latestCoverage.memberCoverageId;
        }
        const furthestDate =
            !!this.state.secondLatestCoverage && !readOnly ? moment(this.state.secondLatestCoverage.startDate) : null;

        let viewOnly = userHasAccess([INFORMATION_AGENT, PLAN_ADMINISTRATOR], true);

        viewOnly = this.getViewOnlyMemberCoverageForClientStatusType();

        const memberCoverageIndex = items.findIndex(
            (item) => item.memberCoverageId === memberCoverage.memberCoverageId
        );
        const previousCoverage = items[memberCoverageIndex + 1];
        const nextCoverage = items[memberCoverageIndex - 1];
        const isArchivedMember = !userHasAccess(FINTECH) && activeMember && activeMember.isArchived;

        viewOnly = viewOnly || isArchivedMember || !!missingProfileFields.length;
        return (
            <ButtonToolbar key={memberCoverage.memberCoverageId}>
                <EditButton
                    modalClassName="extra-large-modal"
                    title={<FormattedMessage id={`memberCoverages.datatable.actions.${viewOnly ? "view" : "edit"}`} />}
                    label={<FormattedMessage id={viewOnly ? "common.view" : "common.edit"} />}
                    allowSubmission={!viewOnly}
                    blockSubmission={
                        this.state.blockInactivationSubmission || this.state.fetchingRetroactiveDate === true
                    }
                    form={BasicMemberCoverageFields}
                    data={{
                        ...memberCoverage,
                        isInactive: memberCoverage.isInactive,
                        mustBePaidToBroker: memberCoverage.mustBePaidToBroker,
                        isPaid: memberCoverage.isPaid,
                        isRemovedFromList: memberCoverage.isRemovedFromList,
                        startDate: moment(toLocaleDate(memberCoverage.startDate)),
                        defineEndDate: memberCoverage.endDate ? true : null,
                        isInactiveWithdrawalDate: memberCoverage.isInactiveWithdrawalDate
                            ? new Date(memberCoverage.isInactiveWithdrawalDate).toLocaleDateString()
                            : null,
                        endDate: memberCoverage.endDate ? moment(toLocaleDate(memberCoverage.endDate)) : null,
                        furthestDate,
                    }}
                    props={{
                        classesList,
                        clientBillingPeriodType,
                        businessAccountType,
                        clientId,
                        clientStatus,
                        isHighManagementWithManager: userHasAccess(MANAGER),
                        latestCoverage: this.state.secondLatestCoverage,
                        previousCoverage,
                        nextCoverage,
                        disabled: viewOnly,
                        ratePeriodType,
                        missingProfileFields,
                        clientLastActiveDate: clientLastActiveDate,
                        setBlockInactivationSubmission: this.setBlockInactivationSubmission,
                        maximumRetroactiveDate: this.state.maximumRetroactiveDate,
                        fetchingRetroactiveDate: this.state.fetchingRetroactiveDate,
                        onStartDateChange: this.onStartDateChange,
                        memberCoverageId: memberCoverage.memberCoverageId,
                        addType
                    }}
                    confirmationValidMessage={() => (
                        <FormattedMessage
                            id="clients.client.processSync.coverageStartDateWarning"
                        />
                    )}
                    confirmationTitle={
                        <FormattedMessage id="common.confirmationWarningTitle">
                            {(f) => <span className="icon warning">{f}</span>}
                        </FormattedMessage>
                    }
                    closeButtonKey="common.cancel"
                    confirmOnClose={true}
                    requiresConfirmation={this.state.isValidForSynchroConfirm}
                    editFunction={this.updateCoverage}
                    readOnly={this.props.isArchived || readOnly || !this.state.areCoveragesEnabledToModification}
                />

            </ButtonToolbar>

        );
    }

    generateAddButton(memberId) {
        const {
            classesList,
            clientBillingPeriodType,
            clientId,
            ratePeriodType,
            businessAccountType,
            clientLastActiveDate,
            activeMember
        } = this.props;
        const { latestCoverage, showErrorModal, showModal, fetchingRetroactiveDate } = this.state;
        const archivedMember = !userHasAccess(FINTECH) && activeMember && activeMember.isArchived;
        return (
            <Render for={AGENT} exactly={PLAN_ADMINISTRATOR} if={!this.props.isArchived && !archivedMember}>
                <Render if={!!latestCoverage}>
                    <DropdownButton
                        className="note-type"
                        id="note-type"
                        pullRight
                        title={<FormattedMessage id="common.options" />}
                    >
                        {memberCoverageAddTypes.map((type, index) => (
                            <MenuItem key={index} eventKey={index} onClick={() => this.openModal(type.value)}>
                                <FormattedMessage id={type.key} />
                            </MenuItem>
                        ))}
                    </DropdownButton>
                </Render>

                <Render if={!latestCoverage}>
                    <DropdownButton
                        className="note-type"
                        id="note-type"
                        pullRight
                        title={<FormattedMessage id="common.options" />}
                    >
                        <Render if={!latestCoverage}>
                            <MenuItem eventKey={NEW} onClick={() => this.openModal(NEW.value)}>
                                <FormattedMessage id={NEW.key} />
                            </MenuItem>
                        </Render>
                    </DropdownButton>
                </Render>

                <Render if={!!showModal}>
                    <BSModal
                        className="extra-large-modal"
                        onClose={this.closeModal}
                        onCloseConfirm={this.closeModalConfirm}
                        onShowConfirm={this.openModalConfirm}
                        showConfirm={this.state.showModalConfirm}
                        show={!!showModal}
                        title={<FormattedMessage id="memberCoverages.datatable.actions.add" />}
                        actions={[
                            {
                                id: 1,
                                disabled: this.state.blockInactivationSubmission || fetchingRetroactiveDate === true,
                                text: <FormattedMessage id="common.confirm" />,
                                action: this.handleSubmit,
                            },
                        ]}
                    >
                        <BasicMemberCoverageFields
                            addType={showModal}
                            add={true}
                            initialValues={
                                showModal !== NEW.value
                                    ? this.cloneLatestCoverageModel()
                                    : this.createEmptyCoverageModel(memberId)
                            }
                            readOnly={this.props.isArchived}
                            onSubmit={this.createCoverage}
                            {...{
                                classesList,
                                businessAccountType,
                                clientBillingPeriodType,
                                clientId,
                                latestCoverage,
                                ratePeriodType,
                                clientLastActiveDate,
                                setBlockInactivationSubmission: this.setBlockInactivationSubmission,
                                maximumRetroactiveDate: this.state.maximumRetroactiveDate,
                                fetchingRetroactiveDate: this.state.fetchingRetroactiveDate,
                                onStartDateChange: this.onStartDateChange,
                            }}
                            ref="form"
                        />
                    </BSModal>
                </Render>

                <Render if={!!showErrorModal}>
                    <BSModal
                        onClose={this.closeErrorModal}
                        show={!!showErrorModal}
                        title={<FormattedMessage id={"memberCoverages.errors.modalTitles.generic"} />}
                    >
                        {this.renderErrorModalContent()}
                    </BSModal>
                </Render>
            </Render>
        );
    }

    getData(offset, limit, q, sortBy, filters) {
        return this.props.dataActions
            .getDataList(
                MEMBER_COVERAGES,
                offset,
                limit,
                q,
                sortBy,
                filters,
                null,
                { clientId: this.props.clientId },
                "*,memberCoverageGuarantees(*)"
            )
            .then((data) => {
                const datum = data.payload.data;
                if (datum.pagination.offset === 0 && datum.pagination.totalCount !== 0 && q === "") {
                    this.setState({
                        latestCoverage: datum.items[0],
                        secondLatestCoverage: datum.items[1],
                    });
                }

                if (canViewSyncStatus(this.props.activeClient, MEMBER)) {
                    this.setState({
                        memberCoverageSyncs: null,
                    });
                    getLatestMemberSyncsV2(this.props.clientId, [this.props.memberId])
                        .then((res) => {
                            const memberCoverageSyncs = res["memberCoverageSyncs"];
                            const memberSyncs = res["memberSyncs"];
                            if (memberCoverageSyncs && memberCoverageSyncs.length > 0) {
                                this.setState({
                                    memberCoverageSyncs: memberCoverageSyncs,
                                });
                            } else {
                                this.setState({ memberCoverageSyncs: [] });
                            }
                            if (memberSyncs && memberSyncs.length > 0) {
                                this.setState({
                                    memberSyncs: memberSyncs,
                                });
                            } else {
                                this.setState({ memberSyncs: [] });
                            }
                        });
                }
            });
    }

    renderErrorModalContent() {
        const { submitErrors } = this.state;

        return (
            <div>
                <MessageBox className="alert-danger">
                    <FormattedMessage id={`memberCoverages.errors.messages.${submitErrors.error}`} />
                </MessageBox>
                {!!submitErrors.data && (
                    <ul>
                        {submitErrors.data.map((field) => (
                            <li key={field}>
                                <FormattedMessage id={`memberCoverages.errors.messages.fields.${field}`} />
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    }

    render() {
        const canAddMemberCoverage = !this.getViewOnlyMemberCoverageForClientStatusType();

        return (
            <DataTable
                ref="dataTable"
                title={<FormattedMessage id="memberCoverages.title" />}
                getData={this.getData}
                cols={this.getCols()}
                q={this.props.q}
                filters={this.props.filters}
                offset={this.props.offset}
                data={this.props.items}
                rowsPerPage={this.props.limit}
                totalRows={this.props.total}
                sortBy={this.props.sortBy}
                addButton={canAddMemberCoverage && this.generateAddButton(this.props.memberId)}
                refreshFunction={this.getData}
            />
        );
    }
}

MemberCoverageDataTable.propTypes = {
    authLanguageCode: PropTypes.string,
    classesList: PropTypes.array,
    clientBillingPeriodType: PropTypes.string,
    businessAccountType: PropTypes.number,
    billingPeriodsList: PropTypes.array,
    clientId: PropTypes.number,
    dataActions: PropTypes.object,
    filters: PropTypes.array,
    getMember: PropTypes.func,
    items: PropTypes.array,
    limit: PropTypes.number,
    memberId: PropTypes.number,
    missingProfileFields: PropTypes.array,
    offset: PropTypes.number,
    q: PropTypes.string,
    ratePeriodType: PropTypes.string,
    sortBy: PropTypes.array,
    total: PropTypes.number,
    clientStatusType: PropTypes.string,
    clientLastActiveDate: PropTypes.string,
    clientStatus: PropTypes.string,
    isArchived: PropTypes.bool,
    activeMember: PropTypes.object,
    activeClient: PropTypes.object,
    addType: PropTypes.string
};

MemberCoverageDataTable.contextTypes = {
    intl: intlShape,
};

function checkMissingProfileFields(member) {
    const missingFields = [];
    for (const field of PROFILE_REQUIRED_FIELDS) {
        if (!member[field]) {
            missingFields.push(field);
        }
    }
    return missingFields;
}

function mapStateToProps(state) {
    const data = state.data.memberCoverages || {};
    const employments = state.data.employments || {};
    const pagination = data.pagination || {};
    const activeMember = state.data.members.active;
    const activeMemberId = activeMember.memberId;
    const newMember = data.memberId !== activeMemberId;
    const billingPeriodsData = state.data.billingPeriodsClientAll || {};
    const client = state.data.members.active.client;
    const clientBillingPeriodType = client.clientBillingPeriodType;
    const businessAccountType = client.businessAccountType;
    const clientLastActiveDate = client.lastActiveDate;
    const clientStatus = client.clientStatusType;
    let missingProfileFields = [];
    if (clientBillingPeriodType === RECURRING.value) {
        const memberEmployments = (employments && Object.keys(employments).length) ? employments.items : [];
        activeMember.employment = (memberEmployments && memberEmployments.length) ? memberEmployments : null;
        missingProfileFields = checkMissingProfileFields(activeMember);
    }
    const addType = state.showModal;

    return {
        activeMember,
        authLanguageCode: state.auth.user.languageCode,
        billingPeriodsList: billingPeriodsData.items || [],
        classesList: state.data.classes ? state.data.classes.items : [],
        clientBillingPeriodType,
        clientStatusType: client.clientStatusType,
        clientStatus,
        businessAccountType,
        clientId: client.clientId,
        clientLastActiveDate: clientLastActiveDate,
        filters: newMember
            ? [`memberCoverages.memberId==${activeMemberId}`]
            : data.filters,
        items: data.items || null,
        limit: pagination.limit || 100,
        memberId: activeMemberId,
        missingProfileFields,
        offset: pagination.offset || 0,
        q: "",
        ratePeriodType: state.data.members.active.client.ratePeriodType,
        sortBy: ["startDate:desc"],
        total: pagination.totalCount || 0,
        isArchived: client.isArchived,
        activeClient: client,
        addType: addType
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MemberCoverageDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/MemberCoverageDataTable.js